<span [class]="'ac-icon ' + ' icon-' + name + ' ac-icon--' + color" [ngClass]="size ? 'ac-icon--' + size : ''"></span>
